(function($, Drupal) {
  Drupal.behaviors.jnjosProducCodesReactObserver = {
    attach(context) {
      const ProductCodesObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.addedNodes.length) {
            Drupal.behaviors.jnjosProductCodesModal.attach($('body'));
          }
        });
      });

      $('div[react-component="hero_card"]', context).each(function() {
        if (!this.hasAttribute('data-mutation-observed-product-codes')) {
          ProductCodesObserver.observe(this, {
            childList: true,
            subtree: true,
          });

          this.setAttribute('data-mutation-observed-product-codes', true);
        }
      });
    },
  };
})(jQuery, Drupal);
